import { Trans } from 'react-i18next';

import styles from './RecaptchaNotice.module.scss';

/** Google's required notice for hiding the reCAPTCHA badge (see .grecaptcha-badge in index.scss). */
export function RecaptchaNotice() {
  return (
    <p className={styles.notice} data-testid="recaptcha-notice">
      <Trans
        components={{
          privacy: <a href="https://policies.google.com/privacy" rel="noreferrer" target="_blank" />,
          terms: <a href="https://policies.google.com/terms" rel="noreferrer" target="_blank" />,
        }}
        i18nKey="auth.recaptchaNotice"
      />
    </p>
  );
}
